import { createFileRoute } from '@tanstack/react-router';

import { getInitialName } from '@/app/utils/string/get-initial-name';
import { Title } from '@/common/components/elements/title';
import { useAuth } from '@/common/hooks/use-auth';
import { BannerGuide } from '@/modules/home/components/banner-guide';
import { CardLink } from '@/modules/home/components/card-link';

const Home = () => {
  const { user } = useAuth();

  return (
    <div className='flex flex-col max-h-sidebar-h overflow-y-auto w-full p-5 mb:p-10'>
      <div className='flex flex-col w-full h-full gap-8'>
        <div className='flex flex-col gap-3'>
          <Title>Olá, {getInitialName(user?.name)}! 👋</Title>
          <span className='flex items-center'>
            <span className='h-px flex-1 bg-border-neutral'></span>
          </span>
        </div>
        <div className='flex w-full flex-col gap-4'>
          <BannerGuide />
          <div className='flex items-center w-full flex-col gap-5 mb:flex-row'>
            <CardLink
              to='/explorar'
              title='Explorar Projetos'
              description='Descubra novos projetos disponíveis'
            />
            <CardLink to='/projetos' title='Seus Projetos' description='Acesse os seus projetos' />
          </div>
        </div>
      </div>
    </div>
  );
};

export const Route = createFileRoute('/_app/_dashboard/')({
  component: Home,
});
